module.exports = function(val) {
	return val.split('').reverse().join('');
};